/**
 * @generated SignedSource<<0039314d62eb088749f261b8d8df7fef>>
 * @relayHash a2c1d2b49046524561f7c3982661a14c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a2c1d2b49046524561f7c3982661a14c

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type SteeringLevelValue = "FOUR" | "MINUS_ONE" | "ONE" | "THREE" | "TWO" | "ZERO";
export type SetSteeringLevelsInput = {
  isAutomatic: boolean;
  language: Language;
  level: SteeringLevelValue;
};
export type useSetSteeringLevelsMutation$variables = {
  inputs: ReadonlyArray<SetSteeringLevelsInput>;
};
export type useSetSteeringLevelsMutation$data = {
  readonly setSteeringLevels: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null;
    readonly steeringLevel: ReadonlyArray<{
      readonly id: string;
      readonly isAutomatic: boolean;
      readonly language: Language;
      readonly level: SteeringLevelValue;
      readonly levelValue: number;
    }> | null;
  };
};
export type useSetSteeringLevelsMutation = {
  response: useSetSteeringLevelsMutation$data;
  variables: useSetSteeringLevelsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inputs"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "inputs",
        "variableName": "inputs"
      }
    ],
    "concreteType": "SetSteeringLevelsPayload",
    "kind": "LinkedField",
    "name": "setSteeringLevels",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SteeringLevel",
        "kind": "LinkedField",
        "name": "steeringLevel",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "level",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "levelValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAutomatic",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetSteeringLevelsMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetSteeringLevelsMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "a2c1d2b49046524561f7c3982661a14c",
    "metadata": {},
    "name": "useSetSteeringLevelsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ec5a499be087c52f49c3236ff3823f5f";

export default node;
